import { useTranslation } from "@redotech/redo-i18n";
import type { VerificationState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const VerificationDetails = memo(function VerificationDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<VerificationState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="md">
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Prompt")}
        </Text>
        <RedoTextareaInputField
          placeholder={t(
            "Instructions shown to the worker before the agent verifies the item",
          )}
          setValue={(prompt) => setState((state) => ({ ...state, prompt }))}
          value={state.prompt}
        />
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {t("Next step")}
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
      </Flex>
    </Flex>
  );
});
